import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  Link, 
  Stack,
  Divider
} from '@mui/material';
import { styled } from '@mui/material/styles';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link as RouterLink } from 'react-router-dom';

const FooterContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #8e0000 0%, #c62828 100%)',
  color: 'white',
  padding: theme.spacing(3, 0),
  marginTop: 'auto',
}));

const Footer = () => {
  return (
    <FooterContainer component="footer">
      <Container maxWidth="lg">
        {/* Informations de contact */}
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={3} 
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 3 }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <PhoneIcon sx={{ fontSize: 18, opacity: 0.9 }} />
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              450 300-5005
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <EmailIcon sx={{ fontSize: 18, opacity: 0.9 }} />
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              info@vitasecours.ca
            </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" spacing={1}>
            <LocationOnIcon sx={{ fontSize: 18, opacity: 0.9 }} />
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
              Saint-Jérôme, QC
            </Typography>
          </Stack>
        </Stack>

        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', mb: 3 }} />

        {/* Copyright et liens */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: { xs: 'column', sm: 'row' }, 
          justifyContent: 'space-between', 
          alignItems: 'center',
          gap: 2 
        }}>
          <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
            © {new Date().getFullYear()} Académie Vita Secours
          </Typography>

          <Stack direction="row" spacing={3} flexWrap="wrap" justifyContent="center">
            <Link 
              component={RouterLink}
              to="/faq" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                fontSize: '0.75rem',
                textDecoration: 'none',
                '&:hover': { 
                  color: '#ffffff', 
                  textDecoration: 'underline' 
                }
              }}
            >
              FAQ
            </Link>
            <Link 
              component={RouterLink}
              to="/politique-cookies" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                fontSize: '0.75rem',
                textDecoration: 'none',
                '&:hover': { 
                  color: '#ffffff', 
                  textDecoration: 'underline' 
                }
              }}
            >
              Cookies
            </Link>
            <Link 
              component={RouterLink}
              to="/declaration-confidentialite" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                fontSize: '0.75rem',
                textDecoration: 'none',
                '&:hover': { 
                  color: '#ffffff', 
                  textDecoration: 'underline' 
                }
              }}
            >
              Confidentialité
            </Link>
            <Link 
              component={RouterLink}
              to="/conditions-inscription" 
              sx={{ 
                color: 'rgba(255, 255, 255, 0.7)', 
                fontSize: '0.75rem',
                textDecoration: 'none',
                '&:hover': { 
                  color: '#ffffff', 
                  textDecoration: 'underline' 
                }
              }}
            >
              Conditions d'inscription
            </Link>
          </Stack>
        </Box>

        {/* Adresse complète (petit en bas) */}
        <Typography 
          variant="caption" 
          align="center" 
          sx={{ 
            display: 'block', 
            mt: 2, 
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '0.7rem'
          }}
        >
          275 Bd des Laurentides, Saint-Jérôme, QC J7Z 7K8
        </Typography>
      </Container>
    </FooterContainer>
  );
};

export default Footer;